import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
var VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
};
var sUserAgent = navigator.userAgent.toLowerCase();
var ua = navigator.userAgent;
var bIsIpad = sUserAgent.match(/iPad/i) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) == "iPad";
var isSafari = ua.indexOf("Safari") != -1 && ua.indexOf("Version") != -1;
var isIphone = ua.indexOf("iPhone") != -1 && ua.indexOf("Version") != -1
var isIPad = isSafari && !isIphone && 'ontouchend' in document;
var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
var bIsMidp = sUserAgent.match(/midp/i) == "midp";
var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
var bIsAndroid = sUserAgent.match(/android/i) == "android";
var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
let userEn = "pc";
if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || isIPad) {
	userEn = "phone";
} else {
	userEn = "pc";
}

export default new Router({
	routes: [
		{
			path: '/',
			name: 'Index',
			component: Index => require(['@/pages/index'], Index),
			
			redirect: userEn === 'pc' ? '/indexPage' : '/mobileMain',
			children: [
				{
					path: '/indexPage',
					name: 'IndexPage',
					component: IndexPage => require(['@/pages/indexPage'], IndexPage),
				},
				{
					path: '/mobileMain',
					name: 'mobileMain',
					component: mobileMain => require(['@/pages/mobileMain'], mobileMain),
				},
				{
					path: '/newsPage',
					name: 'newsPage',
					component: newsPage => require(['@/pages/newsPage'], newsPage),
							
				},
				{
					path: '/newsDetailPage',
					name: 'newsDetailPage',
					component: newsDetailPage => require(['@/pages/newsDetailPage'], newsDetailPage),
				},
				{
					path: '/mNewsPage',
					name: 'mNewsPage',
					component: mNewsPage => require(['@/pages/mNewsPage'], mNewsPage),
				},
				{
					path: '/mNewsDetailPage',
					name: 'mNewsDetailPage',
					component: mNewsDetailPage => require(['@/pages/mNewsDetailPage'], mNewsDetailPage),
				},
			]
		}
	],
})



// WEBPACK FOOTER //
// ./src/router/index.js